import Departments from './Departments';
export default Departments;
